<template>
<div @keyup.esc.prevent="$emit('changeVisibility')" class="fixed z-10 inset-0 overflow-y-auto" aria-labelledby="modal-title" role="dialog" aria-modal="true">
  <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
    <!--
      Background overlay, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0"
        To: "opacity-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100"
        To: "opacity-0"
    -->
    <div @click="$emit('changeVisibility')" class="fixed inset-0 bg-gray-700 bg-opacity-60 transition-opacity" aria-hidden="true"></div>

    <!-- This element is to trick the browser into centering the modal contents. -->
    <span class="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>

    <!--
      Modal panel, show/hide based on modal state.

      Entering: "ease-out duration-300"
        From: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        To: "opacity-100 translate-y-0 sm:scale-100"
      Leaving: "ease-in duration-200"
        From: "opacity-100 translate-y-0 sm:scale-100"
        To: "opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
    -->
    <div class="inline-block align-bottom bg-white dark:bg-gray-900 rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-3/4">
      <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4 group dark:bg-gray-900">
          <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
            <h3 class="text-lg leading-6 font-medium text-gray-900 dark:text-gray-300" id="modal-title">
              Importar lojas
            </h3>
            <div class="mt-2 ">
              <p class="text-sm text-gray-600 dark:text-gray-400">
                Importe arquivo .xlsx.
              </p>
              <div v-show="isEmpty" class="w-full h-52 border-gray-400 dark:border-gray-600 border-2 border-dashed text-center mt-4 flex flex-col select-none cursor-pointer content-center  transition-colors duration-300 hover:bg-gray-200 dark:hover:bg-gray-800">
                <input type="file" @change="handleFileUpload()" name="fields[assetsFieldHandle][]" id="assetsFieldHandle" class="bg-blue-300 h-full opacity-0 cursor-pointer" ref="file" accept=".xlsx" />
                <div class="-mt-36 text-gray-800 dark:text-gray-500">
                  <span class="material-icons-outlined group-hover:animate-bounce text-3xl">
                    add_circle_outline
                  </span>
                  <p class="text-lg">Arraste e solte arquivo ou clique aqui</p>
                </div>
              </div>
              <div v-if="!isEmpty" class=" text-gray-800 dark:text-gray-300 flex gap-x-4 h-24 items-center">
                <span class="material-icons-outlined text-6xl my-auto text-indigo-500 dark:text-indigo-400 select-none">
                  file_present
                </span>
                <p class="">{{file.files[0].name}}</p>
                <span @click="removeFile()" class="material-icons-outlined text-2xl select-none hover:text-indigo-500 duration-300 cursor-pointer transition-all">
                  close
                </span>
              </div>
            </div>
          </div>
      </div>
      <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse dark:bg-gray-900">
        <button type="button" @click="sendFile()" class="btn w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-indigo-600 text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 sm:ml-3 sm:w-auto sm:text-sm" :disabled="isEmpty">
          Importar
        </button>
        <button @click="$emit('changeVisibility')" type="button" class="btn mt-3 w-full inline-flex justify-center px-4 py-2 ext-base font-medium text-gray-800 dark:text-gray-100 sm:mt-0 sm:ml-3 sm:w-auto sm:text-sm">
          Cancelar
        </button>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { ref } from '@vue/reactivity'
import { IMPORT_ADESAO } from '../../mixins/api'
import { displayNotification } from '../../mixins/notification'

export default {
    name: 'FileModal',
    components: {
    },
    setup(_, {emit}) {
      const file = ref(null)
      const isEmpty = ref(true)

      const handleFileUpload = (() => {
        isEmpty.value = false
      })

      const sendFile = (() => {
        let formFile = new FormData()
        formFile.append('filename', file.value.files[0])

        IMPORT_ADESAO(formFile).then(r => {
          displayNotification(r)
          emit('changeVisibility')
        }).catch(e => {
          displayNotification(e.response)
        })
      })

      const removeFile = (() => {
        isEmpty.value = true
      })

      return {
        sendFile,
        handleFileUpload,
        isEmpty,
        removeFile,
        file
      }
    }
}
</script>

<style scoped>

.fade-enter-from {
  opacity: 0;
}
.fade-enter-to {
  opacity: 1;
}

.fade-enter-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-active {
  transition: all 0.3s ease-in-out;
}

.fade-leave-from {
  opacity: 1;
}

.fade-leave-to {
  opacity: 0;
}

</style>